<template>
  <nav class="sidebar-nav">
    <VuePerfectScrollbar dir="ltr" class="scroll-area" :settings="psSettings">
    <ul class="nav" :dir="$dir.ltr ? 'ltr' : 'rtl'">
      <template v-for="(item, index) in navItemsFiltered">
        <template v-if="allowed(item.permissions) && item.title">
          <SidebarNavTitle :key="index" :name="item.name" :classes="item.class" :wrapper="item.wrapper"/>
        </template>
        <template v-else-if="item.divider">
          <SidebarNavDivider :key="index" :classes="item.class"/>
        </template>
        <template v-else-if="item.label">
          <SidebarNavLabel :key="index" :name="item.name" :url="item.url" :icon="item.icon" :label="item.label" :classes="item.class"/>
        </template>
        <template v-else>
          <template v-if="item.children && allowed(item.permissions)">
            <!-- First level dropdown -->
            <SidebarNavDropdown :class="item.parentClass" :key="index" :name="item.name" :url="item.url" :icon="item.icon" :goUrl="item.goUrl" :urlPath="item.urlPath" class="first-level">
              <template v-for="(childL1, index1) in item.children">
                <template v-if="allowed(childL1.permissions) && childL1.children">
                  <!-- Second level dropdown -->
                  <SidebarNavDropdown :key="index1" :name="childL1.name" :url="childL1.url" :icon="childL1.icon" class="second-level" >
                    <li :key="index2" class="nav-item" v-for="(childL2, index2) in childL1.children" >
                      <template v-if="allowed(childL2.permissions)">
                        <SidebarNavLink :name="childL2.name" :url="childL2.url" :icon="childL2.icon" :badge="childL2.badge" :variant="item.variant"/>
                      </template>
                    </li>
                  </SidebarNavDropdown>
                </template>
                <template v-else-if="allowed(childL1.permissions)">
                  <SidebarNavItem :key="index1" :classes="item.class">
                    <SidebarNavLink  :name="childL1.name" :url="childL1.url" :icon="childL1.icon" :badge="childL1.badge" :variant="item.variant"/>
                  </SidebarNavItem>
                </template>
              </template>
            </SidebarNavDropdown>
          </template>
          <template v-else>
            <SidebarNavItem v-if="allowed(item.permissions)" :key="index" :classes="item.class">
              <SidebarNavLink v-if="item.targetBlank" fromStore :target="item.targetBlank" :name="item.name" :url="item.url" :icon="item.icon" :badge="item.badge" :variant="item.variant"/>
              <SidebarNavLink v-else :name="item.name" :url="item.url" :icon="item.icon" :badge="item.badge" :variant="item.variant"/>
            </SidebarNavItem>
          </template>
        </template>
      </template>
      <a :class="'nav-link'" class="cursor-pointer" @click.prevent="logOutPopUp = !logOutPopUp">
        <i class="nav-icon">
          <font-awesome-icon icon="sign-out-alt" class="signOutIcon"/>
        </i>
        Log out
      </a>
    </ul>
    <slot></slot>
    </VuePerfectScrollbar>
    <logout v-model="logOutPopUp"/>
    
  
  </nav>
</template>

<script>
import SidebarNavDivider from './SidebarNavDivider'
import SidebarNavDropdown from './SidebarNavDropdown'
import SidebarNavLink from './SidebarNavLink'
import SidebarNavTitle from './SidebarNavTitle'
import SidebarNavItem from './SidebarNavItem'
import SidebarNavLabel from './SidebarNavLabel'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import config from 'SrcConfig'
import { permissionsHaveNamespaces } from '@/lib/account'
import Logout from "../../../shared/logout";
import switchAccountKeypad from "../../../account/SwitchAccountKeypad";
import * as types from '@/store/types'
export default {
  name: 'SidebarNav',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  components: {
    Logout,
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel,
    VuePerfectScrollbar,
    switchAccountKeypad
  },
  data () {
    return {
      navItemsFiltered:[],
      logOutPopUp: false,
      loading: false,
      psSettings: {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX: true,
        wheelPropagation: false,
        interceptRailY: styles => ({ ...styles, height: 0 }),
        

      },
      hasMenuBoardPermission:undefined,
      logOutTimeout: undefined,
      logOutTimeOutTime: undefined,
    }
  },
  watch: {
  
  '$store.state.initialAutoLogoutTimer': {
      handler: function(newVal) {
        //console.log("1 ", newVal, "logout timer started from watch initialAutoLogoutTimer")
        if(newVal){
          if(this.$store.state.autoLogoutTimerValue){
            //console.log("1 new timer started with new value from vuex: ", this.$store.state.autoLogoutTimerValue)
            this.logOutTimeOutTime = this.$store.state.autoLogoutTimerValue * 1000
            this.startTimeout()
          }else{
            //console.log("1 new timer started with default value: ", 90)
            this.logOutTimeOutTime = 90 * 1000
            this.startTimeout()
          }
        }else{
          //console.log("1 logout timer stopped, general page logout set to false")
          this.stopTimeout()
        }
      },
      immediate: true
    },
  '$store.state.autoLogoutTimerValue': {
      handler: function(newVal) {
        //console.log("2 ", newVal)

        if(this.$store.state.initialAutoLogoutTimer){
          //console.log("2 new timer value: ", newVal, "logout timer started from watch autoLogoutTimerValue")
          this.logOutTimeOutTime = newVal * 1000
          this.startTimeout()
        }
      },
      immediate: true
  },
  },
  beforeDestroy(){
    console.log("beforeDestroy")
  },
  mounted(){

    document.addEventListener("click", ()=>{
        if(this.logOutTimeout && !this.$store.state.requiredPin && this.$store.state.initialAutoLogoutTimer) {
          console.log("in click", this.logOutTimeout)
          this.startTimeout()
        }
        });
    document.addEventListener("scroll", ()=>{
      if(this.logOutTimeout && !this.$store.state.requiredPin && this.$store.state.initialAutoLogoutTimer){
        //console.log("in scroll", this.logOutTimeout)
        this.startTimeout()
      }  
        
    });
    this.$api.publicClient.GetRestaurantInfo({RestaurantID:localStorage.getItem("selectedRestaurant")}).then(res=>{
      if(this.navItems){
        this.navItemsFiltered = this.navItems
      }
      if(res.success){
        
        if(res.results.myAllowAutomaticLogout){
          this.$store.commit(types.SET_AUTO_LOGOUT_TIMER_VALUE, res.results.myAutomaticLogoutTimeThreshold)

          this.logOutTimeOutTime = res.results.myAutomaticLogoutTimeThreshold * 1000
          //.log("in getRestaurantInfo", this.logOutTimeOutTime)
          this.$store.commit(types.SET_INITIAL_AUTO_LOGOUT_TIMER, true)
          this.startTimeout()
        }

        
         if(!res.results.myKioskOrderingService && !res.results.myOrderServiceDinein && !res.results.myOrderServicePickup && !res.results.myOrderServiceDelivery){
          localStorage.setItem("AllOrderingDisabled", true)

           //hiding nav items under reports 
          let indexOfEOD = this.navItemsFiltered[0].children.map(el=>el.name).indexOf("endOfDay");
          if (indexOfEOD > -1) { 
            this.navItemsFiltered[0].children.splice(indexOfEOD, 1);
          }
          let indexOfTS = this.navItemsFiltered[0].children.map(el=>el.name).indexOf("tipSummary");
          if (indexOfTS > -1) { 
            this.navItemsFiltered[0].children.splice(indexOfTS, 1);
          }
          let indexOfSI = this.navItemsFiltered[0].children.map(el=>el.name).indexOf("SalesInsights");
          if (indexOfSI > -1) { 
            this.navItemsFiltered[0].children.splice(indexOfSI, 1);
          }
          //hiding main nav items
          let indexOfTT = this.navItemsFiltered.map(el=>el.name).indexOf("ticket")
          
          if (indexOfTT > -1) { 
            this.navItemsFiltered.splice(indexOfTT, 1);
          }
          let indexOfSEO = this.navItemsFiltered.map(el=>el.name).indexOf("specialEventOrders")
          if (indexOfSEO > -1) { 
            this.navItemsFiltered.splice(indexOfSEO, 1);
          }
          let indexOfCT = this.navItemsFiltered.map(el=>el.name).indexOf("createTab")
          if (indexOfCT > -1) { 
            this.navItemsFiltered.splice(indexOfCT, 1);
          }

          //hiding setting section nav items

          let indexOfSettings = this.navItemsFiltered.map(el=>el.name).indexOf("settings")

          if(indexOfSettings>-1){
            let indexOfP = this.navItemsFiltered[indexOfSettings].children.map(el=>el.name).indexOf("pickup");
            if (indexOfP > -1) { 
              this.navItemsFiltered[indexOfSettings].children.splice(indexOfP, 1);
            }
            let indexOfD = this.navItemsFiltered[indexOfSettings].children.map(el=>el.name).indexOf("delivery");
            if (indexOfD > -1) { 
              this.navItemsFiltered[indexOfSettings].children.splice(indexOfD, 1);
            }
            let indexOfDI = this.navItemsFiltered[indexOfSettings].children.map(el=>el.name).indexOf("dineIn");
            if (indexOfDI > -1) { 
              this.navItemsFiltered[indexOfSettings].children.splice(indexOfDI, 1);
            }
          }

        }else{
          localStorage.setItem("AllOrderingDisabled", false)
        }

      }else{
        localStorage.setItem("AllOrderingDisabled", false)
      }
      if(!res.results.myHaveMenuboardPermission){
        //remove menu board if doesn't have permission
        let indexOfVisuals = this.navItemsFiltered.map(el=>el.name).indexOf("visuals")

        let indexOfMB = this.navItemsFiltered[indexOfVisuals].children.map(el=>el.name).indexOf("menuBoard");
            if (indexOfMB > -1) { 
              this.navItemsFiltered[indexOfVisuals].children.splice(indexOfMB, 1);
            }
      }
      

     
    }).catch(() => {
      // Don't leave the sidebar permanently empty if this request fails
      // (e.g. missing/stale RestaurantID right after a re-login); fall back
      // to showing the full, unfiltered nav rather than nothing at all.
      if (this.navItems && !this.navItemsFiltered.length) {
        this.navItemsFiltered = this.navItems
      }
    })

  },
  

  
  methods: {
    startTimeout(){
      //console.log("startTimeout" , this.logOutTimeout)
      this.stopTimeout()
      //console.log("setting timeout to: ", this.logOutTimeOutTime)
      this.logOutTimeout = window.setTimeout(() => {
        //console.log("timeout reached", this.$store.state.initialAutoLogoutTimer)
        if(this.$store.state.initialAutoLogoutTimer){
          //console.log(" setting requiredPin to true")
          if(localStorage.getItem("ClientTypeID") !== "8"){//if the client type is not 8(kds) don't require passcode 
          this.$store.commit(types.SET_REQUIRED_PIN, true)
          localStorage.setItem("requirePin", true)
          this.stopTimeout()}
        }
      }, this.logOutTimeOutTime)
    },
    stopTimeout(){
      console.log("stopTimeout" , this.logOutTimeout)
      if(this.logOutTimeout)
        window.clearTimeout(this.logOutTimeout)
      
    },
    
    allowed (permissions) {
      let allowed = false
      if (!permissions || !Array.isArray(permissions) || !permissions.length) {
        allowed = true
      } else if (localStorage.getItem('ClientTypeID')) {
        let getCurrentUserClient = localStorage.getItem('ClientTypeID')
        let find = permissions.filter(item => item === +getCurrentUserClient)
        if (find.length) {
          allowed = true
        } else {
          allowed = false
        }
      }
      return allowed
    }
  }
}
</script>

<style scoped lang="css">
  .scroll-area {
    position: absolute;
    height: 100%;
    margin: auto;
  }
  .signOutIcon{
    transform: rotate(180deg);
  }
</style>
